import IsBetweenFilterParser from '../../../osd/filters/parsers/is-between-filter-parser';
import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchEnhancedFilterModel } from '../../../elasticsearch/elasticsearch-filter';
import { BaseExploreFilterParser } from './base';
/**
 * Elastic to ElasticsearchEnhancedFilterModel 'IS BETWEEN' filter parser
 */
export class ExploreFilterIsBetweenFilterParser extends BaseExploreFilterParser {
    constructor() {
        super(new IsBetweenFilterParser());
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchEnhancedFilterModel();
        filter.type = 'IS_BETWEEN';
        filter.value = metadata.params;
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== 'IS_BETWEEN' || !filter.field)
            return null;
        return { [this.baseFilterParser.elasticKey]: { [filter.field.name]: filter.value } };
    }
}
//# sourceMappingURL=is-between.js.map